<template>
  <div>
    <v-menu
        dark
        bottom
        left
        offset-x
        nudge-right="32"
        nudge-bottom="28"
        :close-on-content-click=true
        :close-on-click=false
        transition="slide-y-transition"
        v-model="menuOpen"
        v-if="$vuetify.breakpoint.smAndUp"
    >
      <template v-slot:activator="{ on: { click }}">
        <div id="menu-btn" @click="(click) (menuOpen=!menuOpen) (overlayOpen = !overlayOpen)">
          <img
              class="menu-icon"
              v-if="!menuOpen"
              src="../assets/image/menu.png"
              srcset="../assets/image/menu@2x.png 2x,
                    ../assets/image/menu@3x.png 3x"
              alt="menu"
          />
          <img
              class="close-icon"
              v-else
              src="../assets/image/close.png"
              srcset="../assets/image/close@2x.png 2x,
                    ../assets/image/close@3x.png 3x"
              alt="close"
          />
        </div>
      </template>
      <v-list width="214px">
        <v-list-item :key="1">
          <router-link to="/" class="nav-menu-link" @click.native="reloadPage">
            <v-list-item-title class="nav-menu-link-color">
              Discover
            </v-list-item-title>
          </router-link>
        </v-list-item>
        <v-list-item :key="2">
          <router-link to="/login" class="nav-menu-link">
            <v-list-item-title class="nav-menu-link-color">
              GPVS Portal
            </v-list-item-title>
          </router-link>
        </v-list-item>
        <v-list-item :key="3">
          <a
              target="_blank"
              href="mailto:info@inheritthemusic.com"
              class="nav-menu-link">
            <v-list-item-title class="nav-menu-link-color">
              Contact
            </v-list-item-title>
          </a>
        </v-list-item>
        <v-list-item :key="4">
          <router-link to="/terms-conditions#terms" class="nav-menu-link">
            <v-list-item-title class="nav-menu-link-color">Terms of Use</v-list-item-title>
          </router-link>
        </v-list-item>
        <v-list-item :key="5">
          <router-link to="/terms-conditions#privacy" class="nav-menu-link">
            <v-list-item-title class="nav-menu-link-color">Privacy</v-list-item-title>
          </router-link>
        </v-list-item>
        <v-list-item :key="6">
          <router-link to="/end-user-agreement" class="nav-menu-link">
            <v-list-item-title class="nav-menu-link-color">End User Agreement</v-list-item-title>
          </router-link>
        </v-list-item>
        <v-list-item :key="7">
          <router-link to="/terms-conditions#copyright" class="nav-menu-link">
            <v-list-item-title class="nav-menu-link-color">Copyright</v-list-item-title>
          </router-link>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-if="$vuetify.breakpoint.xsOnly">
      <img
          class="menu-icon"
          v-if="!overlayOpen"
          src="../assets/image/menu.png"
          srcset="../assets/image/menu@2x.png 2x,
                    ../assets/image/menu@3x.png 3x"
          alt="menu"
          @click="overlayOpen = true"
      />
      <v-overlay :value="overlayOpen" opacity="1" class="nav-menu-overlay-cont" color="black" width="100%">
        <div class="nav-menu-overlay-close-cont">
          <img
              class="overlay-close-icon"
              src="../assets/image/close.png"
              srcset="../assets/image/close@2x.png 2x,
                    ../assets/image/close@3x.png 3x"
              alt="close"
              @click="overlayOpen = false"
          />
        </div>
        <div class="nav-menu-overlay-items">
          <router-link to="/" @click.native="reloadPage"><div class="nav-menu-overlay-item">Discover</div></router-link>
          <router-link to="/login"><div class="nav-menu-overlay-item">GPVS Portal</div></router-link>
          <a
              target="_blank"
              href="mailto:info@inheritthemusic.com"
              class="nav-menu-link">
            <div class="nav-menu-overlay-item">Contact</div>
          </a>
          <router-link to="/terms-conditions#terms"><div class="nav-menu-overlay-item">Terms of Use</div></router-link>
          <router-link to="/terms-conditions#privacy"><div class="nav-menu-overlay-item">Privacy</div></router-link>
          <router-link to="/end-user-agreement"><div class="nav-menu-overlay-item">End User Agreement</div></router-link>
          <router-link to="/terms-conditions#copyright"><div class="nav-menu-overlay-item">Copyright</div></router-link>
        </div>
      </v-overlay>
    </div>
  </div>
</template>
<script>
  export default {
    component: 'TopMenu',
    props: {
      reloadPage: {
        type: Function
      }
    },
    data() {
      return {
        menuOpen: false,
        overlayOpen: false,
      }
    }
  }
</script>
<style lang="scss">
.menu-icon {
  width: 29px;
  height: 9px;
  cursor: pointer;
}

.menu-icon:hover,
.close-icon:hover,{
  opacity: 0.8;
}

.close-icon,
.overlay-close-icon {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.overlay-close-icon {
  margin-right: 24px;
}

.nav-menu-link {
  text-decoration: none;
}

.nav-menu-link-color {
  color: white;
}

.v-list-item {
  cursor: pointer;
}

.nav-menu-overlay-close-cont {
  width: 100%;
  display: flex;
  justify-content: center;
}

.nav-menu-overlay-cont {
  height: 325px;
  width: 100%;
}

.nav-menu-overlay-cont.v-overlay--content {
  width: 100%;
  height: 100%;
}

.nav-menu-overlay-item {
  text-transform: uppercase;
  font-family: Lato-Bold, sans-serif;
  font-size: 15px;
  color: white;
  margin: 36px 0;
}

@media only screen and (min-width: 501px) and (max-width: 640px) {
  .nav-menu-overlay-cont {
    height: 350px;
  }
}

</style>